/**
 * Document title for an app-shell route (WCAG 2.4.2 Page Titled).
 *
 * Each layout already owns a `{ suffix, label }` nav table; this resolves the
 * current path against it so every authenticated page gets a distinct title
 * and none is left stale after SPA navigation. Deepest match wins, so
 * `/clients/abc` and `/intelligence/graph` fall back to their section label;
 * an unlisted route falls back to the product name.
 */
type TitledRoute = { suffix: string; label: string; children?: readonly TitledRoute[] };

export function pageTitle(routes: readonly TitledRoute[], suffix: string, product: string): string {
  const flat = routes.flatMap((r) => [r, ...(r.children ?? [])]);
  const hit = flat.find((r) => r.suffix === suffix)
    ?? flat
      .filter((r) => r.suffix !== '' && suffix.startsWith(`${r.suffix}/`))
      .sort((a, b) => b.suffix.length - a.suffix.length)[0];
  return hit ? `${hit.label} — ${product}` : product;
}
